import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApisService } from 'app/services/apis.service';
import { environment } from 'environments/environment.staging';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pending-details',
  templateUrl: './pending-details.component.html',
  styleUrls: ['./pending-details.component.scss']
})
export class PendingDetailsComponent implements OnInit {
  public userId : any
  public userData : any

  rejectionReason = "" 

  constructor(
    private activatedRoute : ActivatedRoute ,
    private apiService : ApisService , 
    private modal : NgbModal, 
    private toastr : ToastrService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => { 
      this.userId = params['id'];
      this.pendingUserDetails()
    })
  }

  
  /*----------  Get pending Users details  ----------*/
  pendingUserDetails(): void{
    this.apiService.PendingUserDetails(this.userId).subscribe({
      next: (response: any) => {
          this.userData = response.data
      },
      error(err) {
        console.log("error in fetching data", err);
      },
    })
  }
  
  /*----------  Get User Image  ----------*/
    getFirstImage(postItem): string {
      return postItem?.media
        ? environment.mediaUrl + "/" + postItem.media.url
        : // : "assets/images/logo/logo1.svg";
          "assets/images/goalngo/profile.svg";
    }
  
    
    /*----------  Rejection Modal   ----------*/
    open(content:any){
      this.modal.open(content, { ariaLabelledBy: "modal-basic-title" , centered : true , size : 'lg' });

    }
    
  
  /*----------  Close modal  ----------*/
  Close(){ 
    this.modal.dismissAll()
  }

  
  /*----------  Accepting user Verification request  ----------*/
  acceptUser(){
    this.apiService.acceptUser(this.userId).subscribe({
      next: (response: any) => {
        this.toastr.success("User Verification Request Accepted");
      },
      error(err) {
        this.toastr.error("Something went wrong");
        console.log("error in sending data", err);
      },
    })
  }
  

  
  /*----------  Sending Rejection Reason  ----------*/
  Rejection(): void{
  this.apiService.Rejection(this.userId , this.rejectionReason).subscribe({
    next: (response: any) => {
      this.toastr.success("Message sent successfully");
      this.modal.dismissAll()
    },
    error(err) {
      this.toastr.error("Something went wrong");
      console.log("error in sending data", err);
    },
  })
  }
}
